import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

export default function Nav() {
  const { user, signOut } = useAuth();
  return (
    <header className="container">
      <div className="nav">
        <Link to={user ? '/dashboard' : '/'} className="wordmark">
          ez<em>bounty</em>
        </Link>
        <nav className="nav-links">
          {user ? (
            <>
              <NavLink to="/dashboard" className={({isActive}) => isActive ? 'active' : ''}>Inventory</NavLink>
              <NavLink to="/inbox" className={({isActive}) => isActive ? 'active' : ''}>Inbox</NavLink>
              <NavLink to="/settings" className={({isActive}) => isActive ? 'active' : ''}>Settings</NavLink>
              <button className="btn btn-ghost nav-btn" onClick={signOut}>Sign out</button>
            </>
          ) : (
            <>
              <NavLink to="/signin">Sign in</NavLink>
              <Link to="/signup" className="btn btn-primary nav-btn">Start</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
